import localFont from "next/font/local";

export const fraunces = localFont({
  src: [
    {
      path: "./Fraunces-Variable.ttf",
      style: "normal",
      weight: "100 900",
    },
    {
      path: "./Fraunces-Italic-Variable.ttf",
      style: "italic",
      weight: "100 900",
    },
  ],
  variable: "--font-fraunces",
  display: "swap",
});

export const dmSans = localFont({
  src: [
    {
      path: "./DMSans-Variable.ttf",
      style: "normal",
      weight: "100 1000",
    },
    {
      path: "./DMSans-Italic-Variable.ttf",
      style: "italic",
      weight: "100 1000",
    },
  ],
  variable: "--font-dm-sans",
  display: "swap",
});

export const fontVariableClassName = `${fraunces.variable} ${dmSans.variable}`;
